import { get, post, put, del } from '../utils/request';
import { Grade, PaginatedResponse } from '../types';

// 获取当前用户角色
function getUserRole(): string | null {
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    return JSON.parse(userInfo).role;
  }
  return null;
}

// 根据角色获取 API 路径
function getGradeEndpoint(): string {
  const role = getUserRole();
  if (role === 'super_admin') return '/admin/grades';
  if (role === 'uploader') return '/uploader/grades';
  return '/campus/grades';
}

// 获取成绩列表
export async function getGradeList(params?: any): Promise<PaginatedResponse<Grade>> {
  return get<PaginatedResponse<Grade>>(getGradeEndpoint(), params);
}

// 录入成绩
export async function createGrade(data: Partial<Grade>): Promise<{ id: string }> {
  return post(getGradeEndpoint(), data);
}

// 批量导入成绩
export async function importGrades(grades: Partial<Grade>[]): Promise<any> {
  const role = getUserRole();
  let endpoint = getGradeEndpoint();
  if (role === 'uploader') {
    endpoint = '/uploader/grades/import';
  } else if (role === 'super_admin') {
    endpoint = '/admin/grades/import';
  } else {
    endpoint = '/campus/grades/import';
  }
  return post(endpoint, { grades });
}

// 审核成绩
export async function reviewGrade(id: string, status: 'approved' | 'rejected', rejectReason?: string): Promise<void> {
  const role = getUserRole();
  const endpoint = role === 'super_admin' ? `/admin/grades/${id}/review` : `/campus/grades/${id}/review`;
  return put(endpoint, { status, rejectReason });
}

// 批量审核成绩
export async function batchReviewGrades(ids: string[], status: 'approved' | 'rejected', rejectReason?: string): Promise<{ success: number; failed: number; failedDetails: { id: string; reason: string }[]; total: number }> {
  const role = getUserRole();
  const endpoint = role === 'super_admin' ? '/admin/grades/batch-review' : '/campus/grades/batch-review';
  return post(endpoint, { ids, status, rejectReason });
}

// 更新成绩
export async function updateGrade(id: string, data: Partial<Grade>): Promise<void> {
  const role = getUserRole();
  let endpoint: string;
  if (role === 'super_admin') {
    endpoint = `/admin/grades/${id}`;
  } else if (role === 'uploader') {
    endpoint = `/uploader/grades/${id}`;
  } else {
    endpoint = `/campus/grades/${id}`;
  }
  return put(endpoint, data);
}

// 删除成绩
export async function deleteGrade(id: string): Promise<void> {
  const role = getUserRole();
  let endpoint: string;
  if (role === 'super_admin') {
    endpoint = `/admin/grades/${id}`;
  } else if (role === 'uploader') {
    endpoint = `/uploader/grades/${id}`;
  } else {
    endpoint = `/campus/grades/${id}`;
  }
  return del(endpoint);
}

// 批量删除成绩
export async function batchDeleteGrades(ids: string[]): Promise<{ success: number; failed: number; failedDetails: { id: string; reason: string }[]; total: number }> {
  const role = getUserRole();
  let endpoint: string;
  if (role === 'super_admin') {
    endpoint = '/admin/grades/batch-delete';
  } else if (role === 'uploader') {
    endpoint = '/uploader/grades/batch-delete';
  } else {
    endpoint = '/campus/grades/batch-delete';
  }
  return post(endpoint, { ids });
}

// 获取成绩统计
export async function getGradeStatistics(): Promise<any> {
  const role = getUserRole();
  let endpoint = '/campus/grades/statistics';
  if (role === 'super_admin') {
    endpoint = '/admin/grades/statistics';
  } else if (role === 'uploader') {
    endpoint = '/uploader/grades/statistics';
  }
  return get(endpoint);
}
